import styled from 'styled-components'

import { Props } from './types'

export default styled.form<Props>`
  text-align: ${(props): string => (props.center ? 'center' : 'left')};
  max-width: ${(props): string => (props.short ? '460px' : '100%')};
  margin: auto;
`
